export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-gray-50 to-white pt-24">
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      
      <div className="max-w-[1400px] mx-auto px-20 py-20 w-full relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-7xl font-bold text-gray-900 leading-tight">
                Crafting Premium
              </h1>
              <h1 className="text-7xl font-bold text-gray-900 leading-tight">
                iOS Experiences
              </h1>
              <h1 className="text-6xl font-light text-gray-500 leading-tight">
                Since Day One
              </h1>
            </div>
            <p className="text-lg text-gray-600 leading-relaxed max-w-xl">
              We are a team of experts developing modern applications for the iOS platform. Our products are designed to enhance user experience and improve the security of mobile devices.
            </p>
          </div>

          <div className="relative h-[600px]">
            <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-white rounded-3xl shadow-2xl overflow-hidden transform rotate-3">
              <img
                src="https://public.readdy.ai/ai/img_res/5774e28a7d76936fb36c09a679770e73.jpg"
                alt="iOS App Interface"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute bottom-0 left-0 w-[450px] h-[550px] bg-white rounded-3xl shadow-2xl overflow-hidden transform -rotate-2">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20iOS%20mobile%20phone%20mockup%20displaying%20modern%20app%20interface%20with%20gradient%20background%2C%20clean%20minimalist%20design%20showing%20security%20and%20optimization%20features%2C%20professional%20product%20photography%20with%20soft%20lighting&width=450&height=550&seq=hero-card-2&orientation=portrait"
                alt="iOS Device Mockup"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
